import { Tag } from 'antd'
import React from 'react'

interface Props{
    quantity:number
}

const TagQuantityComponent = ({quantity}:Props) => {
  return (
    <>
    {
        quantity==1 ? <Tag color="#ef4444cf" className='tag-cash'>¡Ultima Disponible!</Tag> :
        <Tag color="#22c55ed0" className='tag-cash'>¡{quantity} Disponibles!</Tag> 
        
    }
    
    </>
  )
}

export default TagQuantityComponent